module.exports = __webpack_public_path__ + "static/media/AutoCAD Mechanical.1e0616a1.png";